import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

type SidebarHeaderProps = {
	collapsed?: boolean;
	children?: React.ReactNode;
	className?: string;
};

const SidebarHeader = ({ children, className, collapsed }: SidebarHeaderProps) => {
	return (
		<div
			className={twMerge(
				clsx(
					'flex items-center self-stretch',
					collapsed ? 'justify-start flex-col gap-8 ' : 'flex-row justify-between gap-2',
					className,
				),
			)}
		>
			{children}
		</div>
	);
};

export default SidebarHeader;
